import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { IconBase } from "src/components/ui/IconBase";
export default memo(forwardRef(function IconSvgDropdown({
  className,
  "data-test-id": dataTest = "IconDropdown",
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IconBase, { ...props, "data-test-id": dataTest, className, innerRef: ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M12.0005 13.6569L6.92092 9.03906L6.08008 9.96399L12.0005 15.3462L17.9209 9.96399L17.0801 9.03906L12.0005 13.6569Z" }) }) });
}));
